export enum AlertUrls {
    Project = '/datatools/dedupe?projectId=',
}
